import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getIsShowSubscription,
  searchTypeSelector,
} from 'src/store/view/selectors';
import { getIsAdmin } from 'src/store/client/selectors';
import {
  isTopHotelNotFoundSelector,
  topHotelNameSelector,
} from 'src/routes/SearchPage/store/hotels/selectors';
import { startSearchAction } from '../../../actions/search';

import {
  firstResultsFetchedSelector,
  isAwaitingFiltration,
} from '../../../searchStatus/selectors';
import { isFiltersHidden } from '../../../selectors/view';
import { isEmptyFiltrationSelector } from '../../../store/emptyFiltration/selectors';
import { getBrowser } from '../../../selectors/browser';
import SearchPageDesktop from './SearchPageDesktop';

const mapStateToProps = (state) => ({
  browser: getBrowser(state),
  hideSidebar: isFiltersHidden(state),
  firstResultsFetched: firstResultsFetchedSelector(state),
  awaitFiltration: isAwaitingFiltration(state),
  isAdmin: getIsAdmin(state),
  isShowSubscription: getIsShowSubscription(state),
  isEmptyFiltration: isEmptyFiltrationSelector(state),
  searchType: searchTypeSelector(state),
  showNoTopHotel:
    isTopHotelNotFoundSelector(state) && !!topHotelNameSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onInitialSearch: bindActionCreators(startSearchAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchPageDesktop);
